import { useAuth } from "@/contexts/AuthContext";
import { Info } from "lucide-react";

export function PublicAccessNotice({ context = "products" }) {
  const { user } = useAuth();
  if (user) return null;
  return (
    <div
      data-testid="public-access-notice"
      className="bg-[#FFF8F0] border border-[#EFE3D2] rounded-md px-3 py-2 flex items-start gap-2 font-ui text-xs text-[#5C6B64]"
    >
      <Info size={12} className="shrink-0 mt-0.5 text-[#C05C45]" />
      <p>
        Stai navigando come <strong className="text-[#1A362D]">ospite</strong>. Per raccontare la tua esperienza o consigliare un libro e/o un gioco, <strong className="text-[#1A362D]">accedi con Google</strong>.
      </p>
    </div>
  );
}
